
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    selectedTab: 'About', // default tab
    selectedTabData: null,
};
const profileTabSectionSlice = createSlice({
    name: 'profileTabSection',
    initialState,
    reducers: {
        setSelectedTab: (state, action) => {
            state.selectedTab = action.payload;
        },
        // setSelectedTabData: (state, action) => {
        //     state.selectedTabData = action.payload;
        // },
        setSelectedTabData: (state, action) => {
            state.selectedTabData = {
                ...state.selectedTabData,
                ...action.payload,
            };
        },
        clearSelectedTabData: (state) => {
            state.selectedTabData = {};
        },

        resetProfile: () => initialState, // reset action
    },
});

export const { setSelectedTab, setSelectedTabData, clearSelectedTabData, resetProfile } = profileTabSectionSlice.actions;

export default profileTabSectionSlice.reducer;
